import styles from '../less/app.less';

// import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';


const arrowPath = 'm17 30.7q-0.3-0.2-0.3-0.5c0-0.2 0.1-0.4 0.2-0.5l8.5-9.3-8.5-9.3c-0.2-0.2-0.2-0.7 0.1-1 0.3-0.3 0.7-0.3 1 0.1l9 9.7c0.3 0.3 0.3 0.7 0 1l-9 9.7c-0.3 0.4-0.7 0.4-1 0.1z';
const featuredSliderElements = document.querySelectorAll('.splide--featured');
const featuredSliderOptions = {
    pagination: false,
    gap: 18,
    arrows: true,
    arrowPath: arrowPath,
    autoWidth: false
}

if (featuredSliderElements.length) {
    for (let i = 0; i < featuredSliderElements.length; i++) {
        const isSubmenu = featuredSliderElements[i].classList.contains('splide--submenu');
        const options = {
            ...featuredSliderOptions,
            arrows: !isSubmenu,
            autoWidth: isSubmenu
        };
        const FeaturedSlider = new Splide(featuredSliderElements[i], options);
        FeaturedSlider.mount();
    }
}

const defaultSliders = document.querySelectorAll('.splide--default');

if (defaultSliders.length) {
    for (let i = 0; i < defaultSliders.length; i++) {

        const DefaultSlider = new Splide(defaultSliders[i], {
            pagination: false,
            gap: 18,
            arrows: true,
            padding: '26%',
            type: 'loop',
            arrowPath: arrowPath,
            breakpoints: {
                749: {
                    gap: 20,
                    padding: '15%',
                },
            }
        });

        DefaultSlider.mount();
    }
}

const productMainSliders = document.querySelector('.splide--product-main');
const productThumbnailSliders = document.querySelector('.splide--product-thumbnails');

if (productThumbnailSliders) {
    const ProductSlider = new Splide(productMainSliders, {
        pagination: false,
        arrows: true,
        perPage: 1,
        arrowPath: arrowPath,
        breakpoints: {
            749: {
                
            }
        }
    });

    const ProductThumbnailSlider = new Splide(productThumbnailSliders, {
        pagination: false,
        arrows: false,
        arrowPath: arrowPath,
        direction: 'ttb',
        perPage: 4,
        heightRatio: 700 / 139,
        gap: 8,
        isNavigation: true,
        wheel: true,
        breakpoints: {
            749: {
                destroy: true,
                direction: 'ltr'
            }
        }
    });

    ProductSlider.sync(ProductThumbnailSlider)
    ProductSlider.mount();

    ProductThumbnailSlider.mount();
}
  
const mobileSliderElements = document.querySelectorAll('.splide--mobile');

if (mobileSliderElements.length) {
    
    for (let i = 0; i < mobileSliderElements.length; i++) {
        const MobileSlider = new Splide(mobileSliderElements[i], {
            pagination: false,
            arrows: false,
            gap: 18,
            drag: false
        });

        MobileSlider.mount();
    }
}

const perkSliderElements = document.querySelectorAll('.splide--perks');

if (perkSliderElements.length) {
    
    for (let i = 0; i < perkSliderElements.length; i++) {
        const PerkSlider = new Splide(perkSliderElements[i], {
            pagination: false,
            arrows: false,
            drag: true,
            autoplay: true,
            interval: 4000
        });

        PerkSlider.mount();
    }
}

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            // hide recommended products on cart page
            if (document.body.classList.contains('page-cart')) return;
            console.log('');

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }

                    if (!this.querySelector('.slideshow-component') && this.classList.contains('complementary-products')) {
                        this.remove();
                    }

                    if (html.querySelector('.splide__slide')) {
                        this.classList.add('product-recommendations--loaded');
                        
                        const recommendedSliders = this.querySelectorAll('.splide--featured');

                        if (recommendedSliders.length) {
                            for (let i = 0; i < recommendedSliders.length; i++) {
                                const isArrows = recommendedSliders[i].classList.contains('complementary-slide');
                                let options = {
                                    ...featuredSliderOptions
                                };
                                if (this.classList.contains('related-products--cart')) {
                                    recommendedSliders[i].removeAttribute('data-splide');
                                    recommendedSliders[i].classList.remove('splide--featured');
                                    const cartSliderOptions = JSON.parse(this.getAttribute("data-splide"));

                                    options = {
                                        ...cartSliderOptions,
                                        ...featuredSliderOptions
                                    }
                                }

                                const RecommendedSlider = new Splide(recommendedSliders[i], options);
                                RecommendedSlider.mount();
                            }
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
    }
}

customElements.define('product-recommendations', ProductRecommendations);


window.mtcTabs = function(container) {
    const tabButtons = container.querySelectorAll('.tabFilter__button');
    const tabs = container.querySelectorAll('.tabContent');

    // Add click event listener to each tab button
    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            this.classList.add('active');
            const tabName = this.getAttribute('data-tab');
            openTab(tabName);
        });
    });

    const initialTabName = tabButtons[0].getAttribute('data-tab');
    openTab(initialTabName);

    function openTab(tabName) {

        tabs.forEach(tab => {
            tab.classList.remove('active');
        });
        tabButtons.forEach(tab => {
            tab.classList.remove('active');
        });

        const selectedTabContent = container.querySelector(`.tabContent[data-tab="${tabName}"]`);
        const selectedTab = container.querySelector(`.tabFilter__button[data-tab="${tabName}"]`);
        selectedTabContent.classList.add('active');
        selectedTab.classList.add('active');
    }
}

const tabsBlocks = document.querySelectorAll('.tabsBlock');

if (tabsBlocks.length) {
    tabsBlocks.forEach(mtcTabs);
}

const lazyVideos = document.querySelectorAll(".lazy-video");

const handleLazyLoad = (video) => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                video.src = video.dataset.src;
                video.load();
                observer.unobserve(video);
            }
        });
    }, {
        root: null,
        threshold: 0,
        rootMargin: "800px"
    });

    observer.observe(video);
};

lazyVideos.forEach(handleLazyLoad);

// open cookies settings via link with a href attribute value of "#manage-cookies"
document.querySelector('[href="#manage-cookies"]').addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector('#cookiescript_badge').click();
});

// show sticky "Add" button on product page
const productFormContainer = document.querySelector('[data-product-form="form"]');
const isMobile = document.body.clientWidth <= 640;

if (productFormContainer && isMobile) {
    const intersectionObserver = new IntersectionObserver((entries) => {
        const outOfView = entries[0].intersectionRatio <= 0;
        const miniCartIsOpen = document.getElementById('cart-drawer').classList.contains('active');

        if (outOfView && !miniCartIsOpen) {
            document.body.classList.add('sticky-add-to-cart');
        } else {
            document.body.classList.remove('sticky-add-to-cart');
        }
    });

    // start observing
    intersectionObserver.observe(productFormContainer);
}